"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iUserConsents = exports.iUpdateFirstTimeUser = exports.iUpdateUser = exports.iUser = exports.iFormattedUser = exports.iFirstTimeUser = exports.iFullFilledUser = exports.iAuthor = exports._iAuthor = exports.iAuthorName = void 0;
const t = require("io-ts");
const AddressDetails = require("./addressDetails");
exports.iAuthorName = t.interface({
    id: t.number,
    uuid: t.string,
    firstName: t.string,
    lastName: t.string
});
exports._iAuthor = t.intersection([
    exports.iAuthorName,
    t.interface({
        email: t.string,
        avatar: t.string,
        company: t.union([t.string, t.null])
    }),
    t.partial({
        addressDetails: t.clean(AddressDetails.iAddressDetails)
    })
]);
exports.iAuthor = t.clean(exports._iAuthor);
const _iUserCommonalities = t.intersection([
    t.interface({
        id: t.number,
        uuid: t.string,
        type: t.keyof({
            User: null,
            ExternalUser: null,
            PendingUser: null
        }),
        email: t.string,
        hasAcceptedTerms: t.boolean,
        avatar: t.string,
        federated: t.boolean,
        level: t.string,
        company: t.union([t.string, t.null])
    }),
    t.partial({
        disabled: t.union([t.boolean, t.null]),
        hasAcceptedMarketingConsent: t.boolean
    })
]);
exports.iFullFilledUser = t.intersection([
    _iUserCommonalities,
    t.interface({
        status: t.literal('VALID'),
        firstName: t.string,
        lastName: t.string,
        addressDetails: t.clean(AddressDetails.iAddressDetails),
        language: t.string
    }),
    t.partial({
        sub: t.string
    })
]);
exports.iFirstTimeUser = t.intersection([
    _iUserCommonalities,
    t.interface({
        status: t.union([
            t.literal('FIRST_TIME'),
            t.literal('TERMS_NOT_ACCEPTED'),
            t.literal('MISSING_INFORMATION')
        ]),
        addressDetails: t.clean(AddressDetails.iAddressDetailsPartial)
    }),
    t.partial({
        firstName: t.string,
        lastName: t.string,
        language: t.string,
        sub: t.string
    })
]);
exports.iFormattedUser = t.interface({
    name: t.string,
    address: t.string,
    email: t.string,
    avatar: t.string,
    telephone: t.string,
    company: t.string,
    title: t.string
});
exports.iUser = t.clean(t.union([exports.iFullFilledUser, exports.iFirstTimeUser]));
const _iUpdateUser = t.intersection([
    t.interface({
        firstName: t.string,
        lastName: t.string,
        title: t.string,
        telephone: t.string,
        email: t.string,
        street: t.string,
        country: t.string,
        postalCode: t.string,
        city: t.string,
        avatar: t.string
    }),
    t.partial({
        id: t.number,
        language: t.string
    })
]);
exports.iUpdateUser = t.clean(_iUpdateUser);
const _iUpdateFirstTimeUser = t.intersection([
    exports.iUpdateUser,
    t.interface({
        language: t.string,
        hasAcceptedTerms: t.boolean,
        termsVersion: t.number
    }),
    t.partial({
        company: t.number,
        hasAcceptedMarketingConsent: t.boolean
    })
]);
exports.iUpdateFirstTimeUser = t.clean(_iUpdateFirstTimeUser);
exports.iUserConsents = t.partial({
    marketing: t.boolean,
    privacyPolicy: t.boolean,
    termsAndConditions: t.boolean
});
//# sourceMappingURL=user.js.map